/**
 * 列表搜索--员工
 */

import { useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react'
import type { RefObject } from 'react'
import { SCommonDialog, STriggerModal } from 'shj-components'
import { Form, Button, Row, Col, message, Table, Input, ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import { selectCustomerList } from './editConfig'
import { getCustomerInfo } from '@/services/homeService'

export function modalSearchFn({ fn, ...rest }) {
  const onClose = () => {
    dialog.destroy()
  }
  const dialog = SCommonDialog({
    title: rest?.label ? rest?.label : '搜索',
    width: 900,
    getContainer: false,
    content: (
      <ConfigProvider locale={zhCN}>
        <ModalSearchDom onClose={onClose} fn={fn} {...rest} />
      </ConfigProvider>
    ),
  })

  return dialog
}

const ModalSearchDom = forwardRef(({ onClose, onOk }: any, ref) => {
  // const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [tableData, setTableData] = useState([])
  const [selectedRowKeys, setSelectedRowKeys]: any[] = useState([])
  const [selectedRows, setSelectedRows] = useState([])
  const [paramObj, setParamObj] = useState(undefined)

  const [form] = Form.useForm()
  // 搜索 & 重置 的下一步
  const handleSubmit = values => {
    // setParamObj(values['searchKey'])
    fetchCustomerInfo(values['searchKey'])
  }
  // 取消选择
  const deselect = () => {
    setSelectedRowKeys([])
    setSelectedRows([])
  }

  const fetchCustomerInfo = (str?:string) => {
    setLoading(true)
    getCustomerInfo(str)
      .then(resp => {
        try {
          let records = resp||[]
          records = records.map((v, i) => {
            return { ...v, ...{ key: i } }
          })
          setTableData(records)
        } catch (error) {}
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchCustomerInfo()
  }, [])

  // 确定
  const handleOk = () => {
    if (selectedRows.length) {
      onOk(selectedRows[0])
      onClose()
      return
    } else {
      message.warning(`请选择`)
    }
  }

  useImperativeHandle(ref, () => ({
    submit: handleOk,
  }))
  return (
    <div>
      <Form form={form} onFinish={handleSubmit} style={{ marginBottom: 15 }}>
        <Row gutter={10}>
          <Col flex={1}>
            <Form.Item name="searchKey" style={{ marginBottom: 0 }}>
              <Input style={{ width: '100%' }} allowClear placeholder="请输入关键词查询" />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button type="primary" htmlType="submit">
                查询
              </Button>
              {selectedRowKeys.length ? (
                <Button style={{ marginLeft: 10 }} onClick={deselect}>
                  取消选择
                </Button>
              ) : null}
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Table
        columns={selectCustomerList}
        dataSource={tableData}
        pagination={false}
        loading={loading}
        rowSelection={{
          selectedRowKeys,
          type: 'radio',
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys)
            setSelectedRows(selectedRows)
          },
        }}
      />
    </div>
  )
})


export const SearchListModal = props => {
  const { open, onClose, onOk } = props
  const ref: RefObject<any> = useRef()
  const handleOk = () => {
    ref.current?.submit()
  }
  return (
    <STriggerModal
      title="选择客户"
      open={open}
      onCancel={onClose}
      okText="确定"
      cancelText="取消"
      width="60%"
      onOk={handleOk}
    >
      <ModalSearchDom ref={ref} {...props} onOk={onOk} />
    </STriggerModal>
  )
}
